/**
 * We need this function to convert the base64 string coming from the cropper Canvas to a blob so we can send it to the server
 *
 * @see https://stackoverflow.com/a/30407959
 * @param {string} dataurl - The base64 string
 * @return {Blob} - The blob object
 */
export function dataURLtoBlob(dataurl: string) {
	const arr = dataurl.split(',');
	const mime = RegExp(/:(.*?);/).exec(arr[0])?.[1] ?? 'image/jpeg';
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new Blob([u8arr], { type: mime });
}
